export const SMART = 11.99;
export const SMART_EXTRA = 9;
export const FLEET_PRICE = 24.99;
export const FLEET_EXTRA = 15;
export const MAX_CAM_COUNT = 999;
